import { useAuthStore } from '@/store/authStore';
import { selectClaimsActions, useClaimsStore } from '@/store/claimsStore';
import {
  selectClaimDocumentsActions,
  useClaimDocumentsStore,
} from '@/store/newClaim/claimDocumentsStore';
import { selectClaimStepsActions, useClaimStepsStore } from '@/store/newClaim/claimStepsStore';
import { selectPoliciesActions, usePoliciesStore } from '@/store/policiesStore';
import { useCallback } from 'react';
import { useShallow } from 'zustand/react/shallow';

function useLogout() {
  const { logoutSession, isAuthenticated } = useAuthStore(
    useShallow(state => ({
      logoutSession: state.logoutSession,
      isAuthenticated: state.isAuthenticated,
    })),
  );

  const { resetAllSteps } = useClaimStepsStore(selectClaimStepsActions);
  const { resetClaimsData, resetClaimsStatus } = useClaimsStore(selectClaimsActions);
  const { resetPoliciesData, resetPoliciesStatus } = usePoliciesStore(selectPoliciesActions);
  const { resetClaimDocumentsData, resetClaimDocumentsStatus } = useClaimDocumentsStore(
    selectClaimDocumentsActions,
  );

  // Clear policies and claims data, its associated statuses.
  const resetAllData = useCallback(() => {
    resetPoliciesStatus();
    resetClaimsStatus();
    resetPoliciesData();
    resetClaimsData();
    resetClaimDocumentsStatus();
    resetClaimDocumentsData();
    resetAllSteps();
  }, [
    resetAllSteps,
    resetClaimsData,
    resetPoliciesData,
    resetClaimsStatus,
    resetPoliciesStatus,
    resetClaimDocumentsData,
    resetClaimDocumentsStatus,
  ]);

  const logoutAndResetAllData = useCallback(() => {
    if (isAuthenticated) {
      logoutSession();
      resetAllData();
    }
  }, [logoutSession, resetAllData, isAuthenticated]);

  return { logoutAndResetAllData };
}

export { useLogout };
